
import { defineComponent } from 'vue'
import { mapActions, mapState } from 'vuex'
import { isEmpty, throttle } from 'lodash'
import NrTooltip from '@nextrequestco/components/src/components/NrTooltip/NrTooltip.vue'
import NrIconButton from '@nextrequestco/components/src/components/NrIconButton/nr-icon-button.vue'
import NrIcon from '@nextrequestco/components/src/components/NrIcon/NrIcon.vue'
import NrButton from '@nextrequestco/components/src/components/NrButton/nr-button.vue'
import NrModal from '@nextrequestco/components/src/components/NrModal/nr-modal.vue'
import NrSelect from '@nextrequestco/components/src/components/NrSelect/nr-select.vue'
import NrLoadingAnimation from '@nextrequestco/components/src/components/NrLoadingAnimation/nr-loading-animation.vue'
import NrSentry from '../../../utils/nr_sentry'
import API from '../../../vue_shared/api'

export default defineComponent({
  name: 'requester-info',
  components: {
    NrTooltip,
    NrIconButton,
    NrIcon,
    NrButton,
    NrModal,
    NrLoadingAnimation,
    NrSelect
  },

  props: {
    prettyId: { type: String },
    canSeeRequesterPanel: { type: Boolean, default: false },
    canSeeRequesterDetails: { type: Boolean, default: false },
    canSeeEmailStatuses: { type: Boolean, default: false },
    name: { type: String },
    email: { type: String },
    address: { type: String },
    phone: { type: String },
    company: { type: String }
  },

  data() {
    return {
      selectedRequester: {},
      emailStatuses: [],
      isLoadingEmailStatuses: false,
      showEmailStatuses: false
    }
  },

  mounted() {
    this.selectedRequester = this.request.requester || {}
  },

  computed: {
    ...mapState('request_show', [
      'dataFetchState',
      'dataOptions',
      'request',
      'currentAction',
      'filteredRequestLoading'
    ]),
    emailStatusesText() {
      if (this.showEmailStatuses) {
        return 'Hide email status'
      } else {
        return 'View email status'
      }
    },
    url() {
      return `/admin/users/${this.request.requester.id}`
    },
    hasAnyEmailStatuses() {
      return !isEmpty(this.emailStatuses)
    },
    emailAvailable(): boolean {
      return this.email !== 'Email Not Available'
    }
  },

  methods: {
    ...mapActions('request_show', [
      'updateRequester',
      'fetchDataOptions',
      'setCurrentAction'
    ]),

    handleDataTyping: throttle(function (searchText = '', dataType) {
      if (!dataType) return
      this.fetchDataOptions({ searchText, dataType })
    }, 400),

    handleDataScroll: throttle(function (dataType) {
      if (!dataType) return
      this.handleDataTyping(this.dataFetchState[dataType].search_text, dataType)
    }, 400),

    loadEmailStatuses: throttle(
      function () {
        this.isLoadingEmailStatuses = true

        API.fetchRequestEmailStatuses(this.prettyId)
          .then((response) => {
            this.emailStatuses = response.data
            this.isLoadingEmailStatuses = false
          })
          .catch(() => {
            this.$toasted.error(
              'Failed to retrieve requester email status information.'
            )
          })
      },
      5000,
      { trailing: false }
    ),

    handleSave() {
      if (!this.selectedRequester?.id) {
        return
      }

      this.updateRequester({
        prettyId: this.prettyId,
        requesterId: this.selectedRequester.id
      })
        .then(() => {
          this.$toasted.success('Requester updated successfully')
        })
        .catch((e) => {
          this.$toasted.error('There was an error updating the request')
          NrSentry.captureError(e)
        })
        .finally(() => {
          this.setCurrentAction('')
        })
    },

    toggleEmailStatuses() {
      this.showEmailStatuses = !this.showEmailStatuses
      if (this.showEmailStatuses) {
        this.loadEmailStatuses()
      }
    }
  }
})
